<template>
  <div>
    <div class="d-flex mb-3" style="flex-wrap: wrap; gap: 10px;">
      <b-button 
        v-for="(button, index) in filtredButtons"
        :key="index"
        @click="generateChartData(button.key)"
        size="sm"
        :variant="selectedFieldKey.includes(button.key) ?  'outline-success' : 'outline-gray'"
        style="text-transform: none; height: 28px;line-height: 1;"
        class="d-flex justify-content-between align-items-center"
      >
        <p
          class="square"
          :style="selectedFieldKey.includes(button.key) ? `background-color: ${button.color};` : 'background-color: #5a6268;'"
        ></p>
        {{ button.label || button.key }}
      </b-button>
    </div>

    <ColumnChart
      :height="500"
      :chartData="chartData"
      :options="chartOptions"
    ></ColumnChart>
  </div>
</template>

<script>
import ColumnChart from '@components/charts/ColumnChart.vue';

export default {
  components: {
    ColumnChart
  },
  props: {
    buttons: {
      type: Array,
      default: () => [],
    },
    items: {
      type: Array,
      default: () => [],
    },
    whatTab: {
      type: String,
      default: 'leads',
    },
  },
  data() {
    return {
      selectedFieldKey: [],
      chartOptions: {
        scales: {
          yAxes: [
            {
              stacked: false,
              ticks: {
                beginAtZero: false,
                min: 0,
              },
            },
          ],
          xAxes: [
            {
              stacked: false,
              ticks: {
                beginAtZero: false,
                min: 1,
              },
            },
          ],
        },
        legend: {
          display: false,
        },
        tooltips: {
          enabled: false,
        },
        responsive: true,
        maintainAspectRatio: false,
      },
      chartData: {},
      barColors: ['#40b590', '#ffed4a', '#c04dae', '#EA7B27', '#9561e2', '#6cb2eb', '#3490dc'],
      lastBarColor: ['#dd1512', '#f4b0af'],
    }
  },
  watch: {
    items: {
      deep: true,
      handler() {
        this.generateChartData();
      },
    },
  },
  computed: {
    filtredButtons() {
      return this.buttons.filter(b => b.key !== 'sum_of_group_2_group_3' && b.key !== 'sum_of_all' && b.label !== 'Все заявки' && b.key !== 'date');
    },
  },
  methods: {
    generateChartData(selectedFieldKey) {
      if (this.whatTab === 'leads') {
        this.generateChartDataLeads(selectedFieldKey)
      } else {
        this.generateChartDataOrders(selectedFieldKey)
      }
    },
    generateChartDataLeads(selectedFieldKey) {
      const lastButtonKey = this.filtredButtons[this.filtredButtons.length - 1].key;

      if (!selectedFieldKey) {
        this.filtredButtons.forEach(b => {
          if (b.key !== lastButtonKey) {
            this.selectedFieldKey.push(b.key)
          }
        })
      }
      if (selectedFieldKey && selectedFieldKey !== lastButtonKey) {
        if (this.selectedFieldKey.includes(lastButtonKey)) {
          this.selectedFieldKey = this.selectedFieldKey.filter(s => s !== lastButtonKey)
        }
        if (this.selectedFieldKey.includes(selectedFieldKey)) {
          this.selectedFieldKey = this.selectedFieldKey.filter(s => s !== selectedFieldKey)
        } else if (selectedFieldKey && !this.selectedFieldKey.includes(selectedFieldKey)) {
          this.selectedFieldKey.push(selectedFieldKey)
        }
      } else if (selectedFieldKey && selectedFieldKey === lastButtonKey) {
        if (this.selectedFieldKey.includes(selectedFieldKey)) {
          this.selectedFieldKey = [];
          this.filtredButtons.forEach(b => {
            if (b.key !== selectedFieldKey) {
              this.selectedFieldKey.push(b.key)
            }
          })
        } else if (selectedFieldKey && !this.selectedFieldKey.includes(selectedFieldKey)) {
          this.selectedFieldKey = [];
          this.selectedFieldKey.push(selectedFieldKey);
        }
      }

      const labels = this.items.map(f => f.date);
      this.filtredButtons[this.filtredButtons.length - 1].color = labels.map((_, idxs) => this.lastBarColor[(this.filtredButtons.length - 1) % this.lastBarColor.length])[0];

      let datasets = [];

      if (!this.selectedFieldKey.includes(lastButtonKey)) {
        for (let i = 0; i < (this.filtredButtons.length - 1); i++) {
          datasets.push({
            data: [],
            barThickness: 'flex',
          })
        }

        datasets.forEach((d, id) => {
          this.items.forEach(item => {
            const cloneData = structuredClone(item);
            delete cloneData.date;
            delete cloneData.other;
            Object.entries(cloneData).forEach(([key, value], idx) => {
              if (idx === id) {
                if (this.selectedFieldKey.includes(key)) {
                  d.data.push(value.length)
                } else {
                  d.data.push(0)
                }
              }
              let currentIndex = '';
              currentIndex = this.filtredButtons.findIndex(b => b.key === key);
              if (currentIndex !== -1) {
                this.filtredButtons[currentIndex].color = labels.map((_, idxs) => this.barColors[idx % this.barColors.length])[0]
              }
            })
          })
          datasets[id].backgroundColor = labels.map((_, idxs) => this.barColors[id % this.barColors.length]);
        })
      } else {
        const data = [];
        this.items.forEach(item => {
          let cloneData = []
          cloneData = this.getValueOfFrod(item);
          data.push(cloneData);
        })
        datasets.push({
          data: data,
          backgroundColor: labels.map((_, idxs) => this.lastBarColor[(this.filtredButtons.length - 1) % this.lastBarColor.length])
        })
      }

      this.chartData = { labels, datasets };
    },
    generateChartDataOrders(selectedFieldKey) {
      const percentageKeys = ['percentage_group_2', 'percentage_group_3'];

      if (!selectedFieldKey) {
        this.filtredButtons.forEach(b => {
          if (!percentageKeys.includes(b.key)) {
            this.selectedFieldKey.push(b.key)
          }
        })
      }
      if (selectedFieldKey && !percentageKeys.includes(selectedFieldKey)) {
        if (this.selectedFieldKey.some(r => percentageKeys.includes(r))) {
          this.selectedFieldKey = this.selectedFieldKey.filter(s => s !== percentageKeys[0] && s !== percentageKeys[1])
        }
        if (this.selectedFieldKey.includes(selectedFieldKey)) {
          this.selectedFieldKey = this.selectedFieldKey.filter(s => s !== selectedFieldKey)
        } else if (selectedFieldKey && !this.selectedFieldKey.includes(selectedFieldKey)) {
          this.selectedFieldKey.push(selectedFieldKey)
        }
      } else if (selectedFieldKey && percentageKeys.includes(selectedFieldKey)) {
        this.selectedFieldKey = this.selectedFieldKey.filter(key => percentageKeys.includes(key));
        if (this.selectedFieldKey.includes(selectedFieldKey)) {
          this.selectedFieldKey = this.selectedFieldKey.filter(key => key !== selectedFieldKey);
        } else if (selectedFieldKey && !this.selectedFieldKey.includes(selectedFieldKey)) {
          this.selectedFieldKey.push(selectedFieldKey);
        }
      }

      const labels = this.items.map(f => f.date);
      let indexPercent1 = this.filtredButtons.findIndex(b => b.key === percentageKeys[0]);
      this.filtredButtons[indexPercent1].color = this.lastBarColor[0];
      let indexPercent2 = this.filtredButtons.findIndex(b => b.key === percentageKeys[1]);
      this.filtredButtons[indexPercent2].color = this.lastBarColor[1];

      let datasets = [];

      if (!this.selectedFieldKey.some(r => percentageKeys.includes(r))) {
        for (let i = 0; i < (this.filtredButtons.length - 2); i++) {
          datasets.push({
            data: [],
            barThickness: 'flex',
          })
        }
        datasets.forEach((d, id) => {
          this.items.forEach(item => {
            const cloneData = structuredClone(item);
            delete cloneData.date;
            delete cloneData.other;
            Object.entries(cloneData).forEach(([key, value], idx) => {
              if (idx === id + 1) {
                if (this.selectedFieldKey.includes(key)) {
                  d.data.push(value.length)
                } else {
                  d.data.push(0)
                }
              }
              let currentIndex = '';
              currentIndex = this.filtredButtons.findIndex(b => b.key === key);
              if (currentIndex !== -1) {
                this.filtredButtons[currentIndex].color = labels.map((_, idxs) => this.barColors[idx % this.barColors.length])[0]
              }
            })
          })
          datasets[id].backgroundColor = labels.map((_, idxs) => this.barColors[(id + 1) % this.barColors.length]);
        })
      } else {
        for (let i = 0; i < (this.filtredButtons.length - 2); i++) {
          datasets.push({
            data: [],
            barThickness: 'flex',
          })
        }
        datasets.forEach((d, id) => {
          const data = [];
          this.items.forEach(item => {
            let cloneData = '';
            if (id === 0) {
              if (this.selectedFieldKey.includes(percentageKeys[id])) {
                cloneData = this.getPercentageGroup2(item);
              } else {
                cloneData = 0
              }
            } else if (id === 1) {
              if (this.selectedFieldKey.includes(percentageKeys[id])) {
                cloneData = this.getPercentageGroup3(item);
              } else {
                cloneData = 0
              }
            }
            data.push(cloneData)
          })
          d.data = data;
          d.backgroundColor = labels.map((_, idxs) => this.lastBarColor[id % this.lastBarColor.length]);
        })
      }

      this.chartData = { labels, datasets };
    },
    getSumOfAllGroups(row) {
      let sum = 0;
      for (let key in row) {
        if (Array.isArray(row[key])) {
          sum += row[key].length;
        }
      }
      return sum;
    },
    getValueOfFrod(item) {
      let sumOfAll = this.getSumOfAllGroups(item);
      let group_2 = item['group_2'].length;

      if (sumOfAll === 0 || group_2 === 0) { return 0; }

      return Math.round(group_2 / sumOfAll * 100);
    },
    getPercentageGroup2(item) {
      let group_1 = item['group_1'].length;
      let group_2 = item['group_2'].length;

      if (group_1 === 0 || group_2 === 0) { return 0; }

      return Math.round(group_2 / group_1 * 100);
    },
    getPercentageGroup3(item) {
      let group_1 = item['group_1'].length;
      let group_3 = item['group_3'].length;

      if (group_1 === 0 || group_3 === 0) { return 0; }

      return Math.round(group_3 / group_1 * 100);
    },
  },
  mounted() {
    this.generateChartData();
  },
}
</script>

<style scoped>
.square {
  margin: 0 5px 0 0;
  width: 15px;
  height: 15px;
}
</style>